import { ListItemText, MenuItem, SelectChangeEvent } from "@mui/material";
import {
  CustomIntervalType as CustomIntervalTypeEnum,
  RatelistType as RatelistTypeEnum,
} from "@sinch/core/entities/serverEnums";
import { CustomIntervalType, RatelistType } from "@sinch/types/sinch.types";
import React, { FC, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useCustomIntervalType } from "@sinch/components/application/Rate/useIntervalType";
import type { CreateIntervalFormData } from "@sinch/components/application/RateInterval/CreateInterval/formSchema";
import { SelectInput } from "@sinch/components/form/SelectInput/SelectInput";
import { useMuiController } from "@sinch/components/index";

export const CreateIntervalTypeField: FC<{
  disabled?: boolean;
  ratelistType?: RatelistType | RatelistTypeEnum;
}> = ({ disabled, ratelistType }) => {
  const { t } = useTranslation();
  const {
    field: { onChange, ...field },
  } = useMuiController<CreateIntervalFormData, "type">({ name: "type", disabled });
  const { setValue } = useFormContext();
  const { getOptionsList, getCustomIntervalSchema, getCustomIntervalDescription } = useCustomIntervalType(ratelistType);
  const handleChange = useCallback(
    (event: SelectChangeEvent<CustomIntervalType | CustomIntervalTypeEnum>) => {
      setValue("settings", getCustomIntervalSchema(event.target.value as CustomIntervalType).getDefault());
      onChange(event);
    },
    [onChange, setValue]
  );

  return (
    <SelectInput
      onChange={handleChange}
      {...field}
      disabled={disabled}
      disablePortal
      fullWidth
      label={t("RateUnit.unitType")}
      options={getOptionsList()}
    >
      {getOptionsList().map(({ label, value, ...menuProps }) => (
        <MenuItem key={value} value={value} {...menuProps}>
          <ListItemText primary={label} secondary={getCustomIntervalDescription(value as CustomIntervalType)} />
        </MenuItem>
      ))}
    </SelectInput>
  );
};
